import { render, staticRenderFns } from "./PlayerCombatCarrierEvent.vue?vue&type=template&id=8c88fa98&scoped=true&"
import script from "./PlayerCombatCarrierEvent.vue?vue&type=script&lang=js&"
export * from "./PlayerCombatCarrierEvent.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCombatCarrierEvent.vue?vue&type=style&index=0&id=8c88fa98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c88fa98",
  null
  
)

export default component.exports